import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { initAnalytics } from "../firebase";
import { brand as ds } from "../designSystem";

const STORAGE_KEY = "cookie-consent-v1";
// Andere Fenster (z. B. das Testangebot) warten, bis der Banner weg ist,
// statt sich darunter zu schieben.
export const COOKIE_DECIDED_EVENT = "sb-cookie-entschieden";

export const cookieBannerPending = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored !== "accepted" && stored !== "rejected";
  } catch (e) {
    return true;
  }
};

// Cookie-Consent-Banner gemäß § 25 TDDDG / Art. 6 Abs. 1 lit. a DSGVO.
// - Analyse-Cookies (Google Analytics) werden AUSSCHLIESSLICH nach
//   ausdrücklicher, aktiver Einwilligung ("Akzeptieren") geladen.
// - "Ablehnen" ist gleichwertig sichtbar (kein Dark Pattern).
// - Die Einwilligung ist widerrufbar (Button in der Datenschutzerklärung
//   ruft window.resetCookieConsent() auf).
export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let stored = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      // localStorage nicht verfügbar -> Banner zeigen, nichts laden
    }

    if (stored === "accepted") {
      initAnalytics();
    } else if (stored !== "rejected") {
      setVisible(true);
    }

    // Ermöglicht den Widerruf/das erneute Einblenden aus der Datenschutzseite.
    window.resetCookieConsent = () => {
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch (e) {}
      setVisible(true);
    };
  }, []);

  const decide = (choice) => {
    try {
      localStorage.setItem(STORAGE_KEY, choice);
    } catch (e) {}
    if (choice === "accepted") {
      initAnalytics();
    }
    setVisible(false);
    window.dispatchEvent(new Event(COOKIE_DECIDED_EVENT));
  };

  if (!visible) return null;

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-[300]"
      style={{ padding: ds.gutter }}
      role="dialog"
      aria-label="Cookies und Datenschutz"
    >
      <div
        style={{
          maxWidth: 760,
          margin: "0 auto",
          background: ds.color.surface,
          borderRadius: ds.radius.lg,
          padding: "28px clamp(20px, 4vw, 32px)",
        }}
      >
        <h2
          style={{
            fontFamily: ds.font.display,
            fontWeight: 400,
            fontSize: ds.text.h3,
            lineHeight: ds.leading.tight,
            color: ds.color.ink,
            margin: "0 0 10px",
          }}
        >
          Cookies und Datenschutz
        </h2>
        <p
          style={{
            fontFamily: ds.font.body,
            fontSize: 15,
            lineHeight: 1.6,
            color: ds.color.muted,
            margin: 0,
          }}
        >
          Technisch notwendige Cookies brauchen wir für den Betrieb der Seite.
          Zusätzlich möchten wir mit deiner Einwilligung Google Analytics
          nutzen, um auszuwerten, wie die Seite genutzt wird. Dabei setzt
          Google Cookies, und Daten können in die USA übermittelt werden. Die
          Einwilligung ist freiwillig und jederzeit mit Wirkung für die Zukunft
          widerrufbar. Mehr dazu in der{" "}
          <Link
            to="/datenschutz"
            target="_blank"
            className="sb-link"
            style={{ color: ds.color.ink }}
          >
            Datenschutzerklärung
          </Link>
          .
        </p>

        {/* Beide Optionen gleich groß — kein Dark Pattern. Ein kleinerer
            Ablehnen-Knopf machte die Einwilligung angreifbar (§ 25 TDDDG:
            Ablehnen muss so einfach sein wie Zustimmen). Die Reihenfolge
            ist frei, deshalb steht Ablehnen links. */}
        <div
          style={{
            marginTop: 20,
            display: "flex",
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <button
            onClick={() => decide("rejected")}
            className="sb-btn sb-btn-secondary"
            style={{ flex: "1 1 180px" }}
          >
            Ablehnen
          </button>
          <button
            onClick={() => decide("accepted")}
            className="sb-btn sb-btn-primary"
            style={{ flex: "1 1 180px" }}
          >
            Akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
}
